import { containsEmoji } from '@app/libs/validation';

const blocklist = ['modusign', '모두사인', '모두싸인', '주식회사모두사인', '주식회사모두싸인'];

export default function validateName(name: string): { message: string; success: boolean } {
  let message = '';
  let success = false;

  if (!name) {
    message = '이름 입력은 필수입니다.';
  } else if (name.length < 2) {
    message = '최소 2자 이상 입력해주세요.';
  } else if (name.length > 30) {
    message = '2자 이상 30자 이하로 입력해주세요.';
  } else if (blocklist.some((blockedName) => blockedName === name.toLowerCase().replace(' ', ''))) {
    message = '사용할 수 없는 이름입니다.';
  } else if (containsEmoji(name)) {
    message = '이모지는 사용할 수 없습니다.';
  } else {
    message = '';
    success = true;
  }

  return { success, message };
}
